import { combineReducers } from 'redux'

import atoOverviewReducer from './AtoOverview/reducer'
import awarenessReducer from './Awareness/reducer'
import activityFeedReducer from './Home/ActivityFeed/reducer'
import campaignsReducer from './Home/Campaigns/reducer'
import deepfakeReducer from './Home/Deepfake/reducer'
import emailOverviewReducer from './Home/EmailOverview/reducer'
import insightWidgetReducer from './Home/InsightWidget/reducer'
import mailboxesStatusReducer from './Home/MailboxesStatus/reducer'
import { phishingWidgetRedux } from './Home/PhishingWidget/redux'
import homeReducer from './Home/reducer'
import resolutionCenterReducer from './Home/ResolutionCenter/reducer'
import { resolvedIncidentWidgetRedux } from './Home/ResolvedIncidentWidget/redux'
import { spamWidgetRedux } from './Home/SpamWidget/redux'
import threatTypesReducer from './Home/ThreatTypes/reducer'
import urgentUnclassifiedIncidentsReducer from './Home/UrgentUnclassifiedIncidentsWidget/reducer'
import dashboardMenuReducer from './Menu/reducer'
import threatProtectionFlowReducer from './ThreatProtection/Flow/reducer'
import threatProtectionIncidentOverviewReducer from './ThreatProtection/IncidentOverview/reducer'
import threatProtectionListReducer from './ThreatProtection/List/reducer'
import visualDetectionReducer from './VisualDetection/reducer'

export default function () {
  const initialState = combineReducers({
    menu: dashboardMenuReducer(),
    home: combineReducers({
      self: homeReducer(),
      insightWidget: insightWidgetReducer,
      campaigns: campaignsReducer(),
      phishingWidget: phishingWidgetRedux.reducer,
      spamWidget: spamWidgetRedux.reducer,
      resolvedIncidentWidget: resolvedIncidentWidgetRedux.reducer,
      urgentUnclassifiedIncidents: urgentUnclassifiedIncidentsReducer,
      activityFeed: activityFeedReducer(),
      mailboxesStatus: mailboxesStatusReducer(),
      threatTypes: threatTypesReducer(),
      emailOverview: emailOverviewReducer(),
      deepfake: deepfakeReducer(),
      resolutionCenter: resolutionCenterReducer(),
    }),
    awareness: combineReducers({
      self: awarenessReducer(),
    }),
    atoOverview: combineReducers({
      self: atoOverviewReducer(),
    }),
    threatProtection: combineReducers({
      flow: threatProtectionFlowReducer(),
      list: threatProtectionListReducer(),
      incidentOverview: threatProtectionIncidentOverviewReducer(),
    }),
    visualDetection: combineReducers({
      self: visualDetectionReducer(),
    }),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
